<kendo-window (close)="_closeForm()" title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD'  : '' }}"
  (stateChange)="_onStateChanges($event)" class="fullWidthFormForm" #mainWindow>
  <div class="row addNewForecastForm">
    <div class="col-12">
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="row stepsRowMargin">
            <div class="col-12 stepsColPadding">
              <div class="row">
                <div class="col-12">
                  <p class="step_title">
                    {{ _pageState == 2 ? 'New Barcode Label' : _pageState == 3 ? 'Edit Barcode Label'  : '' }}
                  </p>
                </div>
                <div class="col-12">
                  <div class="bordered_sections_special min-height-section"
                    [class.active-step-report]="currentStep === 0">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label class="control-label trl" for="reportName">Label Name</label>
                          <input #kendo_input_Report_Name type="text"
                            class="k-textbox bordered writebox fullavailableWidth"
                            placeholder="Enter Label Name"
                            [(ngModel)]="_model.name"
                            (ngModelChange)="_nameChange($event)"
                            (keyup.enter)="catalogNameChange()"
                            (keyup.tab)="catalogNameChange()" />
                          </div>
                          <div class="form-group">
                            <label class="control-label trl" for="reportCategory">Source</label>
                            <kendo-combobox #labelType
                              [filterable]="true"
                              class="bordered fullavailableWidth"
                              placeholder="Select Source"
                              [data]="_labelPresetFiltered"
                              textField="name"
                              valueField="id"
                              (filterChange)="_handleLabelTypeFilter($event)"
                              (ngModelChange)="_labelTypeSelectionChange($event)"
                              [(ngModel)]="_model.LabelPresetId">
                            </kendo-combobox>
                          </div>
                          <div class="form-group">
                            <div class="transactions-receive-stock-right-checkbox">
                              <input type="checkbox"
                                class="k-checkbox"
                                id="createAsUrl"
                                [(ngModel)]="_model.isURL"
                                [ngModelOptions]="{standalone: true}"
                                kendoCheckBox />
                                <label class="k-checkbox-label margin-left-5" for="createAsUrl">Create as URL</label>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="control-label trl" for="reportCategory">Custom Size</label>
                              <kendo-combobox #custom_size
                                [suggest]="true"
                                [data]="_customSize"
                                (valueChange)="_customSizeChange($event)"
                                class="bordered fullavailableWidth"
                                placeholder="Select Size">
                              </kendo-combobox>
                            </div>
                            @if (_isCustomSize) {
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label class="control-label trl" for="reportCategory">Width</label>
                                    <kendo-numerictextbox type="number"
                                      placeholder="Width"
                                      style="width: 100%"
                                      class="k-numerictextbox newFormControlWidth"
                                      (ngModelChange)="SetCustomSizeWidth($event);SetCustomSizeAttributes(true)"
                                      [ngModelOptions]="{standalone: true}"
                                      [(ngModel)]="_model.Width"
                                      [min]="1"
                                      [decimals]="0"
                                      [format]="'#'"
                                      [autoCorrect]="true">
                                    </kendo-numerictextbox>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <label class="control-label trl" for="reportCategory">Height</label>
                                    <kendo-numerictextbox type="number"
                                      placeholder="Height"
                                      style="width: 100%"
                                      class="k-numerictextbox newFormControlWidth"
                                      (ngModelChange)="SetCustomSizeHeight($event);SetCustomSizeAttributes(true)"
                                      [ngModelOptions]="{standalone: true}"
                                      [(ngModel)]="_model.Height"
                                      [min]="1"
                                      [decimals]="0"
                                      [format]="'#'"
                                      [autoCorrect]="true">
                                    </kendo-numerictextbox>
                                  </div>
                                </div>
                              </div>
                            }
                            <!-- <div *ngIf="_isCustomSize" class="row">
                            <div class="transactions-receive-stock-right-checkbox">
                              <input
                                type="checkbox"
                                class="k-checkbox"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="_model.IsDefaultSize"
                                kendoCheckBox
                                />
                                <div class="transactions-receive-stock-right-checkbox-text">
                                  Set as Default
                                </div>
                              </div>
                            </div> -->
                            @if (!_isCustomSize) {
                              <div class="form-group">
                                <label class="control-label trl" for="reportCategory">Size</label>
                                <kendo-combobox #labelSize
                                  [filterable]="true"
                                  class="bordered fullavailableWidth"
                                  placeholder="Select Size"
                                  [data]="_labelSizeFiltered"
                                  textField="name"
                                  valueField="id"
                                  (filterChange)="_handleLabelSizeFilter($event)"
                                  (ngModelChange)="_labelSizeSelectionChange($event, false)"
                                  [(ngModel)]="_model.LabelSize">
                                </kendo-combobox>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row stepsRowMargin">
                <div class="col-12 stepsColPadding">
                  <div class="row">
                    <div class="col-12">
                      <p class="step_title">Select Fields</p>
                    </div>
                    <div class="col-12">
                      <div class="bordered_sections_special_small_listbox bordered_sections_special_left minHeightSection leftListbox"
                        [class.active-step-report]="currentStep === 2">
                        @if (_gridFields) {
                          <asap-fields-select-from-boxes [title]="'Fields'"
                            [fields]="_gridFields"
                            [selectedFields]="_selectedgridFields"
                            [displayFieldName]="'title'"
                            [fullWidth]="true"
                            [showFilters]="true"
                            [FromBarcodeEditLabel]="FromBarcodeEditLabel"
                            (selectedFieldsOutput)="GetSelectedGridFields($event)">
                          </asap-fields-select-from-boxes>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row stepsRowMargin">
                <div class="col-12 stepsColPadding">
                  <div class="row">
                    <div class="col-12">
                      <p class="step_title">Select Contact</p>
                    </div>
                    <div class="col-12">
                      <div class="bordered_sections_special min-height-section"
                        [class.active-step-report]="currentStep === 3">
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group">
                              <label class="control-label trl" for="reportName">Filter By</label>
                              <kendo-combobox #filterBy
                                [suggest]="true"
                                [data]="selectedFieldsWithoutBarcodeImage"
                                textField="title"
                                valueField="title"
                                class="bordered fullavailableWidth"
                                placeholder="Select By"
                                (valueChange)="_filterByChange($event)">
                              </kendo-combobox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="row stepsRowMargin">
                <div class="col-12 stepsColPadding">
                  <div class="row">
                    <div class="col-12">
                      <p class="step_title">Label Preview</p>
                    </div>
                    <div class="col-12">
                      <div class="bordered_sections_special_right fullminHeightSection"
                        [class.active-step-report]="currentStep === 4">
                        <!-- <div *ngIf="currentStep !== 4" class="report-overlay"></div> -->
                        <div class="row rowcenteredDisplay">
                          <div class="col-12">
                            @if (_previewDate) {
                              <report-viewer
                                [reportObject]="_previewObject"
                                [barcodeModel]="_model"
                                [definitionOnly]="definitionOnly"
                                [windowMode]="false"
                                (closeForm)="_closeForm()"
                                (maximizeWindow)="  maximizeWindow()"
                                (returnDefinition)="_qrDefinition($event)">
                              </report-viewer>
                            }
                            <div class="reportImageContainer">
                              @if (!_previewDate) {
                                <img
                                  class="reportDefaultImg"
                                  [src]="'/assets/menu/'+ _theme +'/report-image.svg'" />
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <!-- <div class="transaction-section-header"> -->
                      <div class="transaction-section-header-actions header-actions">
                        @if (canAccess('labels','read')) {
                          <button class="hidden-xs asap-btn" kendoButton
                            (click)="_previewBarcode()">
                            <span><img [src]="'/assets/menu/'+ _theme +'/preview-files.svg'" /></span>Preview
                          </button>
                        }
                      </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- *ngIf="_showSave" -->
        @if (_showSave) {
          <div
            class="row mt-3">
            <div class="col-12">
              @if (canAccess('labels','create')) {
                <button kendoButton class="steps_buttons_class" (click)="_onSave('saveAndNew')">
                  <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                  <span>Save and New</span>
                </button>
              }
              <!-- <button   kendoButton class="steps_buttons_class" (click)="_onSave('saveAndLC')">
              <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
              <span>Save and Edit Label Content</span>
            </button>
            <button    kendoButton class="steps_buttons_class" (click)="_onSave('saveAndLF')">
              <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
              <span>Save and Edit Label Format</span>
            </button> -->
            <button kendoButton class="steps_buttons_class" (click)="_onSave('saveAndEL')">
              <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
              <span>Save and Edit Layout</span>
            </button>
            @if (canAccess('labels','create')) {
              <button kendoButton class="steps_buttons_class" (click)="_onSave('saveAndCopy')">
                <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                <span>Save and Copy</span>
              </button>
            }
            <button kendoButton class="steps_buttons_class" (click)="_onSave('saveAndClose')">
              <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
              <span>Save and Close</span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</kendo-window>

